// extracted by mini-css-extract-plugin
module.exports = {"loginWidget":"_3XK6uYkAH0d2CuUu3loHSG","terms":"_3mJdSlRVrT4dLn2_8Nv7Gi"};